import React from 'react';
import { FaDice } from 'react-icons/fa';

interface LogoProps {
  className?: string;
}

/**
 * Theme-adaptive SVG logo for Table Top Archive.
 * Uses CSS variables so it automatically matches the active palette.
 */
const Logo = ({ className = '' }: LogoProps) => (
  <span className={`logo-mark ${className}`} aria-hidden="true">
    <FaDice className="logo-dice-icon" />
    <span className="logo-text-group">
      <span className="logo-text-top">Table Top</span>
      <span className="logo-text-bottom">Archive</span>
    </span>
  </span>
);

export default Logo;
